var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 7.75C13.7812 4.03125 10.7188 0.96875 7 0.96875C3.25391 0.96875 0.21875 4.03125 0.21875 7.75C0.21875 11.4961 3.25391 14.5312 7 14.5312C10.7188 14.5312 13.7812 11.4961 13.7812 7.75ZM7.16406 3.21094C8.72266 3.21094 10.3633 4.41406 10.3633 6C10.3633 8.13281 8.09375 8.16016 8.09375 8.92578V8.95312C8.09375 9.14453 7.92969 9.28125 7.76562 9.28125H6.23438C6.04297 9.28125 5.90625 9.14453 5.90625 8.95312V8.84375C5.90625 7.72266 6.75391 7.28516 7.38281 6.92969C7.92969 6.62891 8.28516 6.41016 8.28516 6C8.28516 5.45312 7.57422 5.09766 7.02734 5.09766C6.28906 5.09766 5.96094 5.45312 5.46875 6.08203C5.35938 6.21875 5.14062 6.24609 5.00391 6.13672L4.04688 5.42578C3.91016 5.31641 3.88281 5.125 3.99219 4.96094C4.73047 3.83984 5.6875 3.21094 7.16406 3.21094ZM7 9.99219C7.68359 9.99219 8.25781 10.5664 8.25781 11.25C8.25781 11.9609 7.68359 12.5078 7 12.5078C6.28906 12.5078 5.74219 11.9609 5.74219 11.25C5.74219 10.5664 6.28906 9.99219 7 9.99219Z",
    fill: "#025652"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/QuestionMark.d54cdb31.svg";
export { ForwardRef as ReactComponent };